import type { ReactNode } from "react";

/**
 * Full-viewport layout — no max-width cap. The 80% zoom default makes
 * the old `max-w-6xl` cap feel cramped on wide monitors; spread the
 * grid out instead and let the internal section grids handle density.
 */
export function DashboardLayout({ children }: { children: ReactNode }) {
	return (
		<main className="min-h-full w-full px-6 py-8 xl:px-10 2xl:px-16">
			{children}
		</main>
	);
}
